import settingsTranslations from './settings.json';
export const { ns } = settingsTranslations;
